import { onUnmounted } from "vue";
import { socketEmitter } from "@/services/socket/socket-emitter";
import type { SocketEventListener, SocketEventMap } from "@/types/socket-events";

export function useSocketEvent<K extends keyof SocketEventMap>(event: K, listener: SocketEventListener<K>) {
  let latestCallId = 0;

  const off = socketEmitter.on(event, (payload) => {
    const current = ++latestCallId;

    void listener(payload, { isLatest: () => current === latestCallId });
  });

  onUnmounted(off);
}
